<template>
  <div class="mainSec">
    <v-card width="600" class="mainCard">
      <v-card-title>Авторизация</v-card-title>
      <v-form v-model="valid">
        <v-container>
          <v-row>
            <v-col
                cols="12"
            >
              <v-text-field
                  v-model="username"
                  :rules="rules"
                  label="Логин"
                  required
              >
                <v-icon
                    slot="prepend"
                    color="blue"
                >
                  mdi-account
                </v-icon>
              </v-text-field>
              <v-text-field
                  v-model="password"
                  :rules="passRules"
                  label="Пароль"
                  type="password"
                  required
              >
                <v-icon
                    slot="prepend"
                    color="blue"
                >
                  mdi-lock
                </v-icon>
              </v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
      <v-btn
          @click="signIn"
          :loading="loading"
          class="mt-4 align-center"
          color="primary"
          block
          large
          elevation="2"
      >
        Авторизоваться
      </v-btn>
<!--      <div class="d-flex justify-center mt-4">-->
<!--        У вас нет аккаунта?<router-link to="/signup" class="mx-2">Зарегистрироваться</router-link>-->
<!--      </div>-->
    </v-card>
  </div>
</template>

<script>
import authorizationApi from "@/api/authorization";
import {showSnackbar} from "@/plugins/eventBus";

export default {
  name: "LoginPage",
  data () {
    return {
      valid: false,
      loading: false,
      alert: false,
      snackbar: true,
      username: '',
      password: '',
      rules: [
        v => !!v || 'Введите логин'
      ],
      passRules: [
        v => !!v || 'Введите пароль',
        v => v.length >= 4 || 'Пароль должен быть больше 4 символов',
      ]
    }
  },
  created() {
    this.$store.dispatch("auth/logout")
    console.log('created')
    localStorage.clear()
  },
  methods: {
    async signIn () {
      if (this.valid) {
        try {
          this.loading = true
          const data = { username: this.username, password: this.password };
          await this.$store.dispatch("auth/login", data)
          this.$router.push("/dashboard");
        } catch (err) {
          console.log(err.status)
          console.log(err.status === 400)
          if (err.status === 400) {
            showSnackbar({
              message: "Неправильный логин или пароль!",
              color: "error",
              timeout: 3000,
            })
          } else {
            showSnackbar({
              message: "Не удалось авторизоваться!",
              color: "warning",
              timeout: 3000,
            })
          }
        } finally {
          this.loading = false
        }
      } else {
        showSnackbar({
          message: "Заполните все поля!",
          color: "info",
          timeout: 3000,
        })
      }
    },
    signIn2 () {
      if (this.valid) {
        this.loading = true
        const data = {
          username: this.username,
          password: this.password
        }
        this.$store.dispatch("users/login", data)
        authorizationApi.login(data).then(resp => {
          authorizationApi.authorize(resp)
          this.$router.push('/dashboard')
        }).catch(err => {
          console.log(err.status)
          console.log(err.status === 400)
          if (err.status === 400) {
            showSnackbar({
              message: "Неправильный логин или пароль!",
              color: "error",
              timeout: 3000,
            })
          } else {
            showSnackbar({
              message: "Не удалось авторизоваться!",
              color: "warning",
              timeout: 3000,
            })
          }
        }).finally(() => {
          this.loading = false
        })
      } else {
        showSnackbar({
          message: "Заполните все поля!",
          color: "info",
          timeout: 3000,
        })
      }
    },
  }
}
</script>

<style scoped>
.mainSec {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}
.mainCard {
  padding: 50px 50px;
}
</style>
